import React, { Component } from "react";
import CommonImageView from "presentational/common/CommonImageView";
import CommonIconView from "presentational/common/CommonIconView";
import OutfitUnitTooltipView from "presentational/common/outfitUnit/OutfitUnitTooltipView";
import config from "lib/fr-config";
import { Link } from "react-router-dom";
import { getImgUrl } from "lib/imageUrlHelper";
import { withStore } from "store/storeHandler";
import PropTypes from "prop-types";
import { getEssentialUrl } from "lib/urlQueryParser";

const colorCss = config.css.color;

const css = {
  icon: {
    width: "100%",
    height: "100%",
    color: "rgba(0, 0, 0, 0.7)"
  },
  imageWrapper: { position: "relative" },
  markedGlass: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    background: colorCss.backgroundColorOfSelectedItem
  }
};

class OutfitUnitView extends Component {
  static propTypes = {
    outfitHash: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    displayOutfitUnitTooltip: PropTypes.bool,

    selectMode: PropTypes.bool,
    isMarkedOutfit: PropTypes.bool,
    onClickInSelectMode: PropTypes.func
  };

  static defaultProps = {
    displayOutfitUnitTooltip: false,

    selectMode: false,
    isMarkedOutfit: false,
    onClickInSelectMode: () => {}
  };

  handleClick = () => {
    const {
      outfitHash,
      image,
      selectMode,
      onClickInSelectMode,
      OutfitDetailActions
    } = this.props;
    if (selectMode) {
      onClickInSelectMode({ outfitHash, image });
    } else {
      OutfitDetailActions.addThumbnailData({ outfitHash, image });
    }
  };

  getImageUnitOnly = () => {
    const { image, isMarkedOutfit } = this.props;

    return (
      <div style={css.imageWrapper} onClick={this.handleClick}>
        <CommonImageView
          imageSrc={getImgUrl("outfit", image)}
          imageRatio={config.outfitImage.THUMBNAIL_RATIO}
        />
        <div style={isMarkedOutfit ? css.markedGlass : null}>
          {isMarkedOutfit && <CommonIconView type={"check"} style={css.icon} />}
        </div>
      </div>
    );
  };

  getImageUnitWithLink = () => {
    const { image, outfitHash } = this.props;
    return (
      <div>
        <Link
          style={{ textDecoration: "none" }}
          to={getEssentialUrl({ type: "outfit", allowRefParam: true })(
            outfitHash
          )}
          onClick={this.handleClick}
        >
          <CommonImageView
            imageSrc={getImgUrl("outfit", image)}
            imageRatio={config.outfitImage.THUMBNAIL_RATIO}
          />
        </Link>
      </div>
    );
  };

  getComponent = () => {
    const { selectMode } = this.props;
    return selectMode ? this.getImageUnitOnly() : this.getImageUnitWithLink();
  };

  render() {
    const { displayOutfitUnitTooltip } = this.props;

    if (displayOutfitUnitTooltip) {
      return (
        <OutfitUnitTooltipView>{this.getComponent()}</OutfitUnitTooltipView>
      );
    } else {
      return <div>{this.getComponent()}</div>;
    }
  }
}

export default withStore({
  dispatchMap: ["outfitDetail"]
})(OutfitUnitView);
